import withPlatform from './with-platform';
export default withPlatform;
